// Timing delays
export const SCROLL_DELAY = 300
export const HIGHLIGHT_DELAY = 300
export const FOCUS_DELAY = 100
export const HIGHLIGHT_DURATION = 1050

// Scroll configuration
export const SCROLL_OFFSET = 300

// Content element selectors
export const getContentSelectors = (contentId: string): string[] => [
    `[data-testid='plain-text-${contentId}']`,
]

// Highlight styles
export const HIGHLIGHT_STYLES = {
    border: '2px solid #1976d2',
    transition: 'all 0.3s ease',
}

// Content placeholder text
export const CONTENT_PLACEHOLDER_TEXT = 'Insert your paragraph, or, paste content.'
